export const DELETE_STORE_ERROR = 'DELETE_STORE_ERROR';
export const DELETE_STORE_SUCCESS = 'DELETE_STORE_SUCCESS';
export const DELETE_STORE_START = 'DELETE_STORE_START';
export const CLEAR_DELETE_STORE = 'CLEAR_DELETE_STORE';
